import { Link } from "react-router-dom";
import { BACKEND_URL } from "@/lib/api";
import { usePages, useTexts } from "@/lib/layout";
import { openCookieSettings } from "@/lib/consent";

const cls = "hover:text-white transition-colors text-left";

const FooterLink = ({ to, href, children, testid }) =>
  href ? <a href={href} className={cls} data-testid={testid}>{children}</a> : <Link to={to} className={cls} data-testid={testid}>{children}</Link>;

const Column = ({ title, children, className }) => (
  <div className={className}>
    {title && <p className="kicker text-gold mb-5">{title}</p>}
    <ul className="space-y-2.5 text-[15px]">{children}</ul>
  </div>
);

export const Footer = ({ categories = [], settings }) => {
  const t = useTexts("layout");
  const pages = usePages();
  const [first, ...rest] = (settings?.site_name || "El Noticiero").split(" ");
  const pageLinks = (group) => pages.filter((p) => p.footer_group === group).map((p) => (
    <li key={p.slug}><FooterLink to={`/${p.slug}`} testid={`footer-page-link-${p.slug}`}>{p.nav_label || p.title}</FooterLink></li>
  ));
  return (
    <footer className="mt-24 bg-ink text-slate-400" data-testid="site-footer">
      <div className="wrap py-16 grid grid-cols-12 gap-y-12 gap-x-8">
        <div className="col-span-12 lg:col-span-4">
          {rest.length > 0 && <p className="font-display italic text-gold text-2xl -mb-2">{first}</p>}
          <p className="font-display font-black text-6xl text-white tracking-tight break-words">{rest.length ? rest.join(" ") : first}</p>
          <p className="mt-5 max-w-md leading-relaxed text-[15px]">{settings?.description}</p>
        </div>
        <Column title={t.footer_sections_title} className="col-span-6 lg:col-span-3">
          {categories.map((c) => <li key={c.slug}><FooterLink to={`/seccion/${c.slug}`} testid={`footer-link-${c.slug}`}>{c.name}</FooterLink></li>)}
        </Column>
        <Column title={t.footer_main_title} className="col-span-6 lg:col-span-2">
          {pageLinks("main")}
          {t.footer_rss && <li><FooterLink href={`${BACKEND_URL}/api/rss.xml`} testid="footer-link-rss">{t.footer_rss}</FooterLink></li>}
          {t.footer_sitemap && <li><FooterLink href={`${BACKEND_URL}/api/sitemap.xml`} testid="footer-link-sitemap">{t.footer_sitemap}</FooterLink></li>}
        </Column>
        <Column title={t.footer_legal_title} className="col-span-12 sm:col-span-6 lg:col-span-3">
          {pageLinks("legal")}
          <li><button type="button" onClick={openCookieSettings} className={cls} data-testid="footer-cookie-settings-btn">{t.footer_cookies}</button></li>
        </Column>
      </div>
      <div className="border-t border-white/10">
        <div className="wrap py-5 flex flex-wrap justify-between gap-3 kicker text-[10px] text-slate-500">
          <span data-testid="footer-bottom-text">© {new Date().getFullYear()} {settings?.site_name || "El Noticiero"}{t.footer_bottom ? ` · ${t.footer_bottom}` : ""}</span>
          {t.footer_admin && <Link to="/admin" className="hover:text-white" data-testid="footer-admin-link">{t.footer_admin}</Link>}
        </div>
      </div>
    </footer>
  );
};
